import { render, staticRenderFns } from "./FavouriteEventCalendar.vue?vue&type=template&id=08f93dd2"
import script from "./FavouriteEventCalendar.vue?vue&type=script&lang=js"
export * from "./FavouriteEventCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports